(() => {
  const countdowns = document.querySelectorAll('[data-preorder-countdown]');

  countdowns.forEach((countdown) => {
    const launchDate = new Date(countdown.dataset.launchDate);

    if (Number.isNaN(launchDate.getTime())) return;

    const redirectUrl = countdown.dataset.redirectUrl;
    let timer = null;

    const updateCountdown = () => {
      const remaining = Math.max(0, launchDate - new Date());

      // Lancement atteint pendant que la page est ouverte : on bascule vers la page de précommande.
      if (remaining === 0 && redirectUrl) {
        window.clearInterval(timer);
        window.location.replace(redirectUrl);
        return true;
      }

      const seconds = Math.floor(remaining / 1000);
      const values = {
        days: Math.floor(seconds / 86400),
        hours: Math.floor((seconds % 86400) / 3600),
        minutes: Math.floor((seconds % 3600) / 60),
        seconds: seconds % 60
      };

      Object.entries(values).forEach(([unit, value]) => {
        const element = countdown.querySelector(`[data-unit="${unit}"]`);
        if (element) element.textContent = String(value).padStart(2, '0');
      });
    };

    if (updateCountdown()) return;
    timer = window.setInterval(updateCountdown, 1000);
  });
})();
